import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_menu = _resolveComponent("vxe-menu");
  return _openBlock(), _createBlock(_component_vxe_menu, {
    collapsed: $setup.menuCollapsed,
    "expand-all": $props.expandAll,
    loading: $props.loading,
    options: $props.items,
    onClick: $setup.handleItemClick
  }, _createSlots({
    icon: _withCtx(() => []),
    _: 2
  }, [_renderList(_ctx.$slots, key => {
    return {
      name: key,
      fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(scope)))])
    };
  })]), 1032, ["collapsed", "expand-all", "loading", "options", "onClick"]);
}